/**
 * A row of headline figures.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readArray, readString } from '@/domain/json'
import type { JsonValue } from '@/domain/json'
import { newId, newKpi, type Kpi, type KpiSection } from '@/domain/section'
import KpiBlock from '@/sections/kpi/KpiBlock.vue'
import KpiInspector from '@/sections/kpi/KpiInspector.vue'
import type { SectionDefinition } from '@/sections/types'

function readKpi(value: JsonValue): Kpi {
  const direction = readString(value, 'direction', 'auto')
  return {
    id: readString(value, 'id') || newId(),
    label: readString(value, 'label'),
    value: readString(value, 'value'),
    change: readString(value, 'change'),
    direction: direction === 'up' || direction === 'down' ? direction : 'auto',
  }
}

export const kpiSection: SectionDefinition<'kpi', KpiSection> = {
  kind: 'kpi',
  band: 'content',

  icon: ['M3.5 12.5V8', 'M8 12.5V4', 'M12.5 12.5V9.5'],

  create: (id, title) => ({
    id,
    kind: 'kpi',
    title,
    items: [newKpi(), newKpi(), newKpi()],
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'kpi',
    title,
    items: readArray(stored, 'items').map(readKpi),
  }),

  block: KpiBlock,
  inspector: KpiInspector,
}
